import {create} from 'zustand';

export const LoadingStore = create((set) => ({
  pending: 0,            // 전체 요청 카운터
  heavy: false,          // 5초 넘은 작업 표시용
  inc: () => set((s) => ({ pending: s.pending + 1 })),
  dec: () => set((s) => ({ pending: Math.max(0, s.pending - 1) })),
  setHeavy: (v) => set({ heavy: v }),
}));
